export enum AppContext {
  INVITE = 'invite',
  KEYWORD = 'keyword',
  LOGIN = 'login',
  NOTIFICATIONS = 'notifications',
  OAUTH = 'oauth',
  POLL = 'poll',
  PLANNING_CENTER_ADD_ON = 'planning-center-add-on',
  REFERRAL = 'referral',
  USER = 'user',
  SIGNUP = 'signup',
  SIGNUP_TAP = 'signup-tap',
  VIDEO = 'video',
  WEB_APP = 'web-app',
  MICROSITE = 'microsite',
}
